import React from 'react';
import { IonList, IonItem, IonLabel } from "@ionic/react";
import styles from './ContactList.module.scss';

interface ContactListProps {
  contacts: any[];
  onSelectContact: (contact: any) => void;
}

export const ContactList: React.FC<ContactListProps> = ({ contacts, onSelectContact }) => {
  return (
    <IonList className={styles.contactsList}>
      {contacts.map((contact, index) => (
        <IonItem key={index} onClick={() => onSelectContact(contact)}>
          <IonLabel>{contact?.name?.display} - {contact?.phones?.[0].number}</IonLabel>
        </IonItem>
      ))}
    </IonList>
  );
};